import * as expressionUtils from '../../../utils/surveys/expressions';

const getThresholdScoreText = ({ min, max }: { min?: expressionUtils.Threshold; max?: expressionUtils.Threshold }) => {
  if (min && max) return `${min.text} (${min.value} - ${Number(max.value) - 1})`;
  else if (min) return `${min.text} (${min.value})`;

  return '';
};

export { getThresholdScoreText };
